import Emily1 from '../../../media/fasad/Emily.webp'
import Emily2 from '../../../media/fasad/Emily.webp'


const Emilyimages =[
Emily1,Emily2
]

export default Emilyimages;